export var createReports = function createReports(emitNotSupportedError, window, wrapSubscribeFunction) {
  return function (options) {
    return wrapSubscribeFunction(function (observer) {
      if (window === null || window.ReportingObserver === undefined) {
        return emitNotSupportedError(observer);
      }
      var reportingObserver = new window.ReportingObserver(function (reportList) {
        return observer.next(reportList);
      }, options);
      reportingObserver.observe();
      return function () {
        return reportingObserver.disconnect();
      };
    });
  };
};